import React, { useEffect, useContext, useState, memo } from "react";
import { Image, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import PlaidAuthenticator from "./PlaidConfig";
import {
  IconButton,
  Separator,
  Spinner,
  context,
} from "../accessories/accessories";
import { web } from "../accessories/Platform";
import { PlaidLink } from "react-plaid-link";
import {
  handleAPI,
  log,
  getQueryString,
  updateWebURL,
} from "../accessories/CommonFunctions";
import ScrollContainer from "../accessories/ScrollContainer.js";
import Icon from "react-native-vector-icons/Entypo";
import {
  client_name,
  publicKey,
  env,
  client_id,
  secret,
  env_url,
  language,
} from "@env";
import ArrowSpinner from "../accessories/ArrowSpinner";
import CustomText from "../accessories/CustomText";
import { Linking } from "react-native";
import { Dimensions } from "react-native";

let From = getQueryString("From", "");
const SessionId = getQueryString("SessionId", "");

const createLinkToken = async () => {
  try {
    const response = await fetch(
      "https://www.solutioncenter.biz/LoginCredentialsAPI/api/createLinkToken_Plaid",
      {
        method: "GET",
        mode: "cors",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch link token");
    }

    return await response.json();
  } catch (error) {
    console.error("Error creating link token:", error);
    return null;
  }
};

const Plaid = (props) => {
  const {
    handleFrameNavigation = () => {},
    handleOptionPress = () => {},
    details = {},
    handleSaveLoanInformation = () => {},
    isBankAccountLinked = 0,
  } = props;
  const sandbox = __DEV__,
    webhook = sandbox
      ? "https://www.plaid.com/webhook"
      : "http://documents.solutioncenter.biz/plaidwebhook/api/plaid";
  const { contextDetails, setContextDetails } = useContext(context);

  const [transactionDetails, setTransactionDetails] = useState(null);
  const [bankDetails, setBankDetails] = useState({
    payrollIncomePublicToken: null,
    bankIncomePublicToken: null,
    user_token: null,
    payroll_income: null,
    bank_income: null,
  });
  const [Liabilities, setLiabilities] = useState({
    liabilitiesPublicToken: null,
    liabilities: null,
  });
  const [identity, setIdentity] = useState(null);
  const [Assets, setAssets] = useState({
    public_token: null,
    access_token: null,
    asset_report_token: null,
    assets: null,
  });
  const [balance, setBalance] = useState(null);
  const [processingStatus, setProcessingStatus] = useState(null);
  // Plaid Json is empty. --

  const [plaidDetails, setPlaidDetails] = useState({
    ...{
      client_name,
      country_codes: ["US"],
      language,
      products: ["auth", "assets"],
      public_token: null,
      access_token: null,
      availableProducts: null,
      isCompleted: false,
    },
    ...(sandbox
      ? {
          publicKey: "eecc6d6382543dbee6478afbc5879b",
          env: "sandbox",
          client_id: "650454e7fce9610018775a83",
          secret: "9bdf4b03db812d29cc64f556ca7124",
          env_url: "https://sandbox.plaid.com",
        }
      : {
          publicKey,
          env,
          client_id,
          secret,
          env_url,
        }),
  });

  const [userDetails, setUserDetails] = useState(details);
  const [isLoading, setIsLoading] = useState(true);
  const [plaidStatus, setPlaidStatus] = useState(null);
  const [linkId, setLnkId] = useState(null);
  useEffect(() => {
    createLinkToken().then((response) => {
      setLnkId(response);
    });
  }, []);
  const [status, setStatus] = useState(
    isBankAccountLinked === 1
      ? [
          {
            primaryMessage: "Bank Account Details",
            secondaryMessage: `Your Bank Account details have been successfully imported.`,
          },
          // {
          //   primaryMessage: "Transaction Details",
          //   secondaryMessage: `Your transaction details have been successfully imported.`,
          // },
          // {
          //   primaryMessage: "Income Details",
          //   secondaryMessage: `Your income details have been successfully imported.`,
          // },
        ]
      : []
  );
  const [uniqueId, setUniqueId] = useState(0);
  const [requiredProducts] = useState([
    ...[
      "assets",
      "auth",
      "transactions",
      "income",
      "liabilities",
      "identity",
      "balance",
      // "income_verification",
    ],
    // ...(sandbox ? ["income_verification"] : []),
  ]);

  useEffect(() => {
    details && setUserDetails(details);
  }, [props]);

  function getElementPosition(element) {
    let top = 0,
      left = 0;
    while (element) {
      top += element.offsetTop || 0;
      left += element.offsetLeft || 0;
      element = element.offsetParent;
    }
    return { top, left };
  }
  if (web) {
    useEffect(() => {
      const openPlaid = () => {
        const plaidElement = document.querySelector(".Plaid");
        if (plaidElement) {
          setTimeout(() => {
            if (!contextDetails["fullScreen"]) {
              const styleElement = document.createElement("style"),
                divPosition = getElementPosition(
                  document.getElementById("divPlaidContainer")
                );
              styleElement.innerHTML = `
        iframe[title="Plaid Link"] {
          width:380px;
          height: calc(100vh - 470px);
          position:absolute !important;
          top:${divPosition.top - 75}px !important;
          left:${divPosition.left}px !important;
          max-height:700px
        } 
        `;
              From != "loginverify" && document.head.appendChild(styleElement);
            }
            plaidElement.click();
            setTimeout(() => {
              try {
                if (!contextDetails["fullScreen"])
                  document.querySelector("#divPlaidContainer").style.height =
                    "750px";
              } catch (error) {}
            }, 800);
          }, 1000);
        } else {
          setTimeout(openPlaid, 100);
        }
      };
      const iUniqueId = uniqueId || getQueryString("uid");
      if (iUniqueId) {
        setUniqueId(iUniqueId);
      } else {
        handleInsertPlaidId();
      }
      openPlaid();
    }, []);
    useEffect(() => {
      if (status.length > 0) {
        if (!contextDetails["fullScreen"])
          document.querySelector("#divPlaidContainer").style.height = "auto";
      }
    }, [status]);
  }
  const handleInsertPlaidId = () => {
    handleAPI({
      name: "PlaidVerify",
      params: {
        LoanId: details["loanId"],
        EmpId: details["loanOfficerId"] || 4142,
        CustId: details["CustId"],
      },
    }).then((response) => {
      setUniqueId(response);
      log("Response form Plaid UniqueId", response);
    });
  };
  const handleLoadStart = (props) => {
    log("handleLoadStart", props);
  };
  const handleLoad = (props) => {
    setIsLoading(true);
  };

  const handleEvent = (props) => {
    if (props === "OPEN") {
      setIsLoading(false);
      if (web) {
        setTimeout(() => {
          try {
            document.querySelector(
              'iframe[title="Plaid Link"]'
            ).style.opacity = 1;
          } catch (error) {}
        }, 1000);
        if (!contextDetails["fullScreen"])
          try {
            document.querySelector("#divPlaidContainer").style.height = "750px";
          } catch (error) {}
      }
    } else if (props === "HANDOFF") {
      setPlaidDetails({ ...plaidDetails, isCompleted: true });
    } else if (props === "EXIT") {
      handleOptionPress(null);
      web &&
        !contextDetails["fullScreen"] &&
        document.querySelector('iframe[title="Plaid Link"]').remove();
    } else if (props === "TRANSITION_VIEW") {
      setPlaidDetails({ ...plaidDetails, isClickedAllow: true });
    }
  };
  function capitalizeFLetter(string) {
    return string[0].toUpperCase() + string.slice(1);
  }

  useEffect(() => {
    if (plaidDetails["metaData"] && !plaidDetails["access_token"]) {
      handleGetAccessToken();
    } else if (plaidDetails["access_token"]) {
      let { availableProducts } = plaidDetails;
      if (!availableProducts) availableProducts = [];
    }
  }, [plaidDetails]);

  useEffect(() => {
    if (
      bankDetails &&
      !bankDetails["bank_income"] &&
      plaidDetails["metaData"]
    ) {
      handleGetBankDetails();
    }
  }, [bankDetails]);

  const handleAssetsWebHooks = async (publicToken, iId, iName) => {
    handleAPI({
      name: "CommonPlaidVerification",
      params: {
        strXML: `<root><MetaData PublicToken="${publicToken}" institution_name="${iName}" institution_id="${iId}"/></root>`,
        uid: uniqueId,
      },
    }).then((response) => {
      setTimeout(() => {
        handleCheckAssetsData(0);
      }, 3000);
      log("Response form CommonPlaidVerification  ===> ", response);
    });
  };
  const navigate = (path, option) => {
    updateWebURL({ ...option, Path: path });
    props["navigation"].navigate(path, option || {});
  };
  const handleLogOut = () => {
    handleAPI({
      name: "LogOutSession",
      params: { SessionId: SessionId },
    })
      .then(() => {
        navigate("Login", {});
      })
      .catch((err) => console.error("Error from LogOutSession ====> ", err));
  };
  const handleCheckAssetsData = (poolCount) => {
    handleAPI({
      name: "CheckAssetFromPlaid",
      params: {
        UniqueId: uniqueId,
      },
    }).then((response) => {
      try {
        console.log("Asset data form plaid", JSON.parse(response));
        const result = JSON.parse(response);
        if (result.length > 0) {
          setContextDetails({
            ...contextDetails,
            isAssetPullCompleted: true,
            pulledAssetCount: result.length,
          });
          setPlaidDetails({ ...plaidDetails, isClickedAllow: false });
        }
      } catch (error) {}
      if (poolCount >= 5) {
        if (From == "loginverify") {
          setProcessingStatus("Plaid Json is empty.");
        } else {
          setStatus((iStatus) => {
            return [
              ...iStatus,
              ...[
                {
                  primaryMessage: "Failed to import Bank Account details.",
                  secondaryMessage: <></>,
                },
              ],
            ];
          });
        }
      } else if (
        JSON.stringify(response).includes("accounts") &&
        JSON.stringify(response).includes("account_id")
      ) {
        handleSaveLoanInformation(1, true);
        if (From == "loginverify") {
          setProcessingStatus("success");
        } else {
          setStatus((iStatus) => {
            return [
              ...iStatus,
              ...[
                {
                  primaryMessage: "Bank Account Details",
                  secondaryMessage: `Your Bank Account details have been successfully imported.`,
                },
              ],
            ];
          });
        }
      } else {
        setTimeout(() => {
          poolCount = poolCount + 1;
          handleCheckAssetsData(poolCount);
        }, 3000);
      }
    });
  };
  const handleSuccess = async (publicToken, metadata) => {
    // setPlaidStatus("Getting Available Products list...");
    // await handleAPI({
    //   name: "PostAPI" || "fnGenericGetAPIData",
    //   params: {
    //     iRequest: JSON.stringify({
    //       institution_id: metadata["institution"]["institution_id"],
    //       country_codes: plaidDetails["country_codes"],
    //       country_codes: plaidDetails["country_codes"],
    //       client_id: plaidDetails["client_id"],
    //       secret: plaidDetails["secret"],
    //     }),
    //     URL: `${plaidDetails["env_url"]}/institutions/get_by_id`,
    //   },
    // })
    //   .then((response) => {
    //     response = JSON.parse("{" + response);
    if (publicToken) {
      setTimeout(() => {
        setPlaidDetails({
          ...{},
          ...plaidDetails,
          ...{
            metaData: metadata,
            availableProducts: requiredProducts,
          },
          ...(!sandbox
            ? {
                public_token: publicToken,
              }
            : {}),
        });
      }, 100);
    }
    if (web && !contextDetails["fullScreen"]) {
      try {
        document.querySelector("#divPlaidContainer").style.height = "";
      } catch (error) {}
    }

    if (!__DEV__) {
      setProcessingStatus("Importing");
      handleAssetsWebHooks(
        publicToken,
        metadata["institution"]["institution_id"],
        metadata["institution"]["name"]
      );
    } else {
      handleSaveLoanInformation(1, true);
    }
    // })
    // .catch((e) => console.log("Error From PostAPI ===> ", e));
  };
  const handleGetAPIData = async (URL, iRequest) => {
    let { env_url } = plaidDetails;
    URL = `${env_url}${URL}`;
    iRequest = JSON.stringify(iRequest);
    return await handleAPI({
      name: "fnGenricPOSTAPI" || "fnGenericGetAPIData",
      params: { iRequest, URL },
    }).then((response) => {
      if (response) {
        response = JSON.parse("{" + response.trim());

        // console.log(
        //   URL.replaceAll(plaidDetails["env_url"], ""),
        //   " =====> ",
        //   response
        // );
        return response;
      }
    });
  };
  const handleGetAccessToken = async () => {
    const {
        client_id,
        secret,
        client_name,
        country_codes,
        language,
        products,
        access_token,
        public_token,
        metaData,
      } = plaidDetails,
      user = { client_user_id: "sep27testcase" },
      purpose = !public_token
        ? "getPublicToken"
        : !access_token
        ? "getAccessToken"
        : "",
      requestOptions = {
        ...{
          client_id,
          secret,
        },
        ...(purpose === "getPublicToken"
          ? sandbox
            ? {
                institution_id: metaData["institution"]["institution_id"],
                initial_products: (
                  plaidDetails["availableProducts"] || requiredProducts
                ).filter((item) => item !== "balance"),
                options: { webhook },
              }
            : {
                client_name,
                country_codes,
                language,
                user,
                products,
              }
          : purpose === "getAccessToken"
          ? { public_token }
          : {}),
      },
      URL = `${
        purpose === "getPublicToken" || purpose === "getVerifyLiabilitiesToken"
          ? sandbox
            ? "/sandbox/public_token/create"
            : `/link/token/create`
          : purpose === "getAccessToken"
          ? `/item/public_token/exchange`
          : ""
      }`;

    const response = await handleGetAPIData(URL, requestOptions);

    let iPlaidDetails = {},
      iAvailableProducts = [];
    if (response["error_code"] && response["error_code"].includes("PRODUCT")) {
      if (response["error_message"].includes("products are not supported")) {
        let unAvailableProducts = JSON.parse(
          response.error_message.split(":")[1].trim().replaceAll(" ", ",")
        );
        iAvailableProducts = plaidDetails["availableProducts"].filter(
          (item) => !unAvailableProducts.includes(item)
        );
        if (unAvailableProducts.join("").includes("income")) {
          iAvailableProducts = iAvailableProducts.filter(
            (item) => item.indexOf("income") === -1
          );
        }
      }
      iPlaidDetails = {
        ...iPlaidDetails,
        ...{
          availableProducts: iAvailableProducts,
          showProducts: true,
        },
      };
      let iPlaidStatus = iAvailableProducts
        .map((item, index) => {
          return { product: capitalizeFLetter(item), status: "pending..." };
        })
        .filter((iItem) => !iItem.product.includes("Auth"));
      setPlaidStatus([...iPlaidStatus]);
    } else if (purpose === "getPublicToken") {
      iPlaidDetails = {
        ...iPlaidDetails,
        ...{
          link_token: response["link_token"],
          public_token: response["public_token"],
        },
      };
    } else if (purpose === "getAccessToken") {
      iPlaidDetails = {
        ...iPlaidDetails,
        access_token: response["access_token"],
      };
      // console.log("access_token ===> ", response["access_token"]);
    }
    setPlaidDetails({ ...plaidDetails, ...iPlaidDetails });
  };
  const handleGetTransaction = async () => {
    const { client_id, secret, access_token } = plaidDetails,
      requestOptions = {
        client_id,
        secret,
        access_token,
        count: 20,
      },
      iTransactionDetails = await handleGetAPIData(
        "/transactions/sync",
        requestOptions
      );
    handleCheckData(
      iTransactionDetails,
      "Transactions",
      "handleGetTransaction()"
    );
    if (!iTransactionDetails["error_code"]) {
      setTransactionDetails(iTransactionDetails);
      if (JSON.stringify(iTransactionDetails).includes("account_id")) {
        setStatus((iStatus) => {
          return [
            ...iStatus,
            ...[
              {
                primaryMessage: "Transaction Details",
                secondaryMessage: `Your transaction details have been successfully imported.`,
              },
            ],
          ];
        });
      }
    }
    // setTransactionDetails(iTransactionDetails);
  };
  const handleGetBankDetails = async () => {
    const { client_id, secret, metaData } = plaidDetails,
      {
        bankIncomePublicToken,
        payrollIncomePublicToken,
        user_token,
        payroll_income,
        bank_income,
      } = bankDetails,
      { userName, loanId } = details,
      requestOptions = {
        ...{
          client_id,
          secret,
        },
        ...(!user_token
          ? {
              client_user_id: sandbox
                ? Math.random().toString(36).slice(2)
                : `${userName.replaceAll(" ", "_")}_${loanId}_${Math.random()
                    .toString(36)
                    .slice(7)}`,
            }
          : !payrollIncomePublicToken //&& sandbox
          ? {
              user_token,
              institution_id: metaData["institution"]["institution_id"],
              initial_products: ["income_verification"],
              options: {
                webhook,
              },
            }
          : !bankIncomePublicToken //&& sandbox
          ? {
              user_token,
              institution_id: metaData["institution"]["institution_id"],
              initial_products: ["income_verification"],
              options: {
                webhook,
                override_password: "{}",
                income_verification: {
                  income_source_types: ["bank"],
                  bank_income: {
                    days_requested: 180,
                  },
                },
              },
            }
          : !payroll_income || !bank_income
          ? {
              user_token,
            }
          : {}),
      },
      URL = !user_token
        ? `/user/create`
        : !payrollIncomePublicToken || !bankIncomePublicToken //&& sandbox
        ? "/sandbox/public_token/create"
        : !payroll_income
        ? "/credit/payroll_income/get"
        : !bank_income
        ? "/credit/bank_income/get"
        : "",
      iResponse = await handleGetAPIData(URL, requestOptions);
    let iBankDetails = bankDetails;

    iBankDetails = {
      ...iBankDetails,
      ...(!user_token
        ? { user_token: iResponse["user_token"] }
        : !payrollIncomePublicToken //&& sandbox
        ? { payrollIncomePublicToken: iResponse["public_token"] }
        : !bankIncomePublicToken //&& sandbox
        ? { bankIncomePublicToken: iResponse["public_token"] }
        : !payroll_income
        ? { payroll_income: iResponse }
        : !bank_income
        ? { bank_income: iResponse }
        : {}),
    };
    if (!bank_income && JSON.stringify(iResponse).includes("bank_income_id")) {
      setStatus((iStatus) => {
        return [
          ...iStatus,
          ...[
            {
              primaryMessage: "Income Details",
              secondaryMessage: `Your income details have been successfully imported.`,
            },
          ],
        ];
      });
    }
    if (URL.includes("payroll_income"))
      handleCheckData(iResponse, "PayrollIncome", "handleGetBankDetails()");
    if (URL.includes("bank_income"))
      handleCheckData(iResponse, "BankIncome", "handleGetBankDetails()");

    if (!iBankDetails["error_code"]) setBankDetails(iBankDetails);
    setBankDetails(iBankDetails);
  };
  // const handleGetAssets = async () => {
  //   const { client_id, secret, access_token } = plaidDetails,
  //     {
  //       asset_report_token,
  //       assets,
  //       public_token,
  //       access_token: accessToken,
  //     } = Assets,
  //     requestOptions = {
  //       ...{
  //         client_id,
  //         secret,
  //       },
  //       ...// !public_token && sandbox
  //       // ? {
  //       //     institution_id: "ins_20",
  //       //     initial_products: ["assets"],
  //       //     options: {
  //       //       webhook: "https://www.genericwebhookurl.com/webhook",
  //       //     },
  //       //   }
  //       // : !accessToken && sandbox
  //       // ? {
  //       //     public_token,
  //       //   }
  //       // :
  //       (!asset_report_token
  //         ? {
  //             access_tokens: [access_token],
  //             days_requested: 30,
  //             options: {
  //               client_report_id: Math.random().toString(36).slice(2),
  //               webhook,
  //               user: {},
  //             },
  //           }
  //         : { asset_report_token }),
  //     },
  //     iResponse = await handleGetAPIData(
  //       !asset_report_token ? "/asset_report/create" : "/asset_report/get",
  //       requestOptions
  //     );

  //   if (asset_report_token || iResponse["error_code"]) {
  //     handleCheckData(
  //       iResponse,
  //       "Assets",
  //       "setTimeout(() =>handleGetAssets(), 5000);"
  //     );
  //   }
  //   if (
  //     (iResponse["report"] || iResponse["asset_report_token"]) &&
  //     !iResponse["error_code"]
  //   ) {
  //     if (asset_report_token) {
  //       handleCheckData(iResponse, "Assets", "handleGetAssets()");
  //     }
  //     if (iResponse["report"] || iResponse["asset_report_token"]) {
  //       let iAssets = Assets;
  //       iAssets = {
  //         ...iAssets,
  //         ...(!asset_report_token
  //           ? { asset_report_token: iResponse["asset_report_token"] }
  //           : { assets: iResponse }),
  //       };
  //       setAssets(iAssets);
  //     } else {
  //       // setTimeout(() => {
  //       //   handleGetAssets();
  //       // }, 200);
  //     }
  //   }
  // };

  // const handleGetLiabilities = async () => {
  //   const { client_id, secret, access_token } = plaidDetails,
  //     { liabilitiesPublicToken, liabilities } = Liabilities,
  //     requestOptions = {
  //       ...{
  //         client_id,
  //         secret,
  //       },
  //       ...(!liabilitiesPublicToken && sandbox
  //         ? {
  //             institution_id: "ins_19",
  //             initial_products: ["liabilities"],
  //             options: {
  //               webhook,
  //             },
  //           }
  //         : { access_token }),
  //     },
  //     iResponse = await handleGetAPIData(
  //       !liabilitiesPublicToken && sandbox
  //         ? "/sandbox/public_token/create"
  //         : "/liabilities/get",
  //       requestOptions
  //     );
  //   let iLiabilities = Liabilities;
  //   iLiabilities = {
  //     ...iLiabilities,
  //     ...(!liabilitiesPublicToken
  //       ? {
  //           liabilitiesPublicToken: iResponse["public_token"],
  //         }
  //       : { liabilities: iResponse }),
  //   };
  //   if (liabilitiesPublicToken || iResponse["error_code"])
  //     handleCheckData(iResponse, "Liabilities", "handleGetLiabilities()");
  //   if (!iResponse["error_code"]) setLiabilities(iLiabilities);

  //   if (liabilitiesPublicToken)
  //     handleCheckData(iResponse, "Liabilities", "handleGetLiabilities()");
  //   setLiabilities(iLiabilities);
  // };

  // const handleGetBalance = async () => {
  //   const { client_id, secret, access_token } = plaidDetails,
  //     requestOptions = {
  //       client_id,
  //       secret,
  //       access_token,
  //     },
  //     iBalance = await handleGetAPIData(
  //       "/accounts/balance/get",
  //       requestOptions
  //     );
  //   handleCheckData(iBalance, "Balance", "handleGetBalance()");

  //   setBalance(iBalance);
  // };

  // const handleGetIdentity = async () => {
  //   const { client_id, secret, access_token } = plaidDetails,
  //     requestOptions = {
  //       client_id,
  //       secret,
  //       access_token,
  //     },
  //     iIdentity = await handleGetAPIData("/identity/get", requestOptions);
  //   handleCheckData(iIdentity, "Identity", "handleGetIdentity()");

  //   setIdentity(iIdentity);
  // };
  const handleCheckData = (data, name, tryAgain) => {
    let status = "Success.",
      color = "green",
      index = null,
      iPlaidStatus = plaidStatus;

    setPlaidStatus((iStatus) => {
      iPlaidStatus = iStatus
        ? iStatus
        : plaidDetails["availableProducts"].map((item, index) => {
            return { product: capitalizeFLetter(item), status: "pending..." };
          });

      iPlaidStatus.forEach((item, iIndex) => {
        if (
          name
            .toString()
            .toUpperCase()
            .includes(item.product.toString().toUpperCase())
        )
          index = iIndex;
      });
      if (data["error_code"] === "PRODUCT_NOT_READY") {
        setTimeout(() => {
          eval(tryAgain);
        }, 4000);
      } else if (data["error_code"]) {
        status = data["error_message"];
        color = "red";
      } else {
        downLoanFile(data, name);
      }
      if (index !== null && data["error_code"] !== "PRODUCT_NOT_READY") {
        let row = iPlaidStatus[index];
        row["status"] = status;
        row["color"] = color;
        iPlaidStatus[index] = row;
      }
      return iPlaidStatus;
    });
    if (data["error_code"] === "PRODUCT_NOT_READY") {
      eval(tryAgain);
    } else if (data["error_code"]) {
      status = data["error_message"];
      color = "red";
    } else {
      downLoanFile(data, name);
    }
    if (index !== null && data["error_code"] !== "PRODUCT_NOT_READY") {
      let row = iPlaidStatus[index];
      row["status"] = status;
      row["color"] = color;
      iPlaidStatus[index] = row;
      setPlaidStatus([...iPlaidStatus]);
    }
  };

  const downLoanFile = (json, name) => {
    name = name + "_" + Math.random().toString(36).slice(2);
    log(name, json);
    if (!sandbox) {
      let dataStr =
          "data:text/json;charset=utf-8," +
          encodeURIComponent(JSON.stringify(json)),
        dlAnchorElem = document.createElement("a");
      dlAnchorElem.setAttribute("href", dataStr);
      dlAnchorElem.setAttribute("download", name + ".json");
      document.body.appendChild(dlAnchorElem);
      dlAnchorElem.click();
      document.body.removeChild(dlAnchorElem);
    }
  };

  const renderLogin = () => {
    return web && linkId ? (
      <PlaidLink
        style={{ display: "none" }}
        clientName={plaidDetails["client_name"]}
        env={plaidDetails["env"]}
        product={plaidDetails["products"]}
        publicKey={plaidDetails["publicKey"]}
        onLoad={handleLoad}
        onEvent={handleEvent}
        onSuccess={handleSuccess}
        className="Plaid"
        webhook={webhook}
        token={linkId}
        // oauthRedirectUri={window.location.href}
      >
        {" "}
      </PlaidLink>
    ) : !web ? (
      !plaidDetails["isCompleted"] && (
        <PlaidAuthenticator
          clientName={plaidDetails["client_name"]}
          env={plaidDetails["env"]}
          product={plaidDetails["products"]}
          publicKey={plaidDetails["publicKey"]}
          handleLoad={handleLoad}
          handleLoadStart={handleLoadStart}
          handleEvent={handleEvent}
          handleSuccess={handleSuccess}
        />
      )
    ) : (
      <></>
    );
  };
  const PlaidStatus = () => {
    return (
      <>
        {status.length > 0 && (
          <>
            {status.map((item, index) => {
              return (
                <View key={index}>
                  <View style={{ flexDirection: "row", paddingTop: 20 }}>
                    <View style={{ flexDirection: "column", flex: 1 }}>
                      <CustomText
                        style={{ fontSize: 20, marginBottom: 10 }}
                        bold={true}
                      >
                        {item["primaryMessage"]}
                      </CustomText>
                    </View>
                  </View>
                  <View style={{ flexDirection: "row" }}>
                    <CustomText style={{ fontSize: 18 }}>
                      {item["secondaryMessage"]}
                    </CustomText>
                  </View>
                </View>
              );
            })}
            <View style={{ marginTop: 40, flex: 1, flexDirection: "row" }}>
              <Icon
                onPress={() => handleSaveLoanInformation(0, false)}
                style={{ marginRight: 5, color: "rgb(44, 134, 209)" }}
                size={20}
                name="circle-with-plus"
              />
              <CustomText
                onPress={() => handleSaveLoanInformation(0, false)}
                style={{
                  ...{
                    fontSize: 18,
                    color: "#1172c1",
                  },
                  ...(web ? { cursor: "pointer" } : {}),
                }}
              >
                Add another Bank Account
              </CustomText>
            </View>
          </>
        )}
        {((plaidDetails["metaData"] &&
          !contextDetails["isAssetPullCompleted"]) ||
          plaidDetails["isClickedAllow"]) && (
          <>
            <View
              style={{
                ...{
                  flexDirection: "row",
                  paddingTop: 20,
                },
              }}
            >
              <CustomText
                style={{
                  marginRight: 5,
                  marginLeft: 2,
                  height: web ? "auto" : 35,
                }}
              >
                <ArrowSpinner style={{ height: 25, marginTop: 0 }} size={22} />
              </CustomText>
              <View
                style={{
                  flexDirection: "column",
                  flex: 1,
                  height: web ? "auto" : 40,
                }}
              >
                <CustomText
                  style={{ fontSize: web ? 20 : 18, marginBottom: 10 }}
                  bold={true}
                >
                  Importing data from Plaid...
                </CustomText>
              </View>
            </View>
          </>
        )}
      </>
    );
  };
  const isMobileWeb = Dimensions.get("window").width <= 480;
  return (
    <ScrollContainer>
      {From == "loginverify" && web && !isMobileWeb ? (
        <div
          style={{
            backgroundImage: `url(${require("../../assets/AdobeStock.png")})`,
            minHeight: "100vh",
            backgroundSize: "82vw 85vh",
            width: "100%",
            backgroundColor: "#fff",
            backgroundPosition: "100px 0",
          }}
        >
          <View style={{ flexDirection: "row", marginTop: 25 }}>
            <Image
              style={{
                position: "relative",
                height: 80,
                width: "20%",
              }}
              resizeMode="contain"
              source={require("../../assets/DMLarge1.png")}
            />
            <View
              style={{
                width: "60%",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CustomText
                style={{
                  color: "#201E5E",
                  fontSize: 45,
                  alignContent: "center",
                }}
                bold={true}
              >
                Asset Verification
              </CustomText>
            </View>
          </View>
          {isLoading && isBankAccountLinked !== 1 && (
            <View style={styles["Wrapper"]}>
              <View
                style={[
                  {
                    ...{
                      flexDirection: "row",
                      paddingTop: 20,
                    },
                  },
                ]}
              >
                <CustomText
                  style={{
                    marginRight: 5,
                    marginLeft: 2,
                    height: web ? "auto" : 35,
                  }}
                >
                  <ArrowSpinner
                    style={{ height: 25, marginTop: 0 }}
                    size={22}
                  />
                </CustomText>
                <View
                  style={{
                    flexDirection: "column",
                    flex: 1,
                    height: web ? "auto" : 40,
                  }}
                >
                  <CustomText
                    style={{ fontSize: web ? 20 : 18, marginBottom: 10 }}
                    bold={true}
                  >
                    Connecting to Plaid...
                  </CustomText>
                </View>
              </View>
              <View style={{ flexDirection: "row" }}>
                <CustomText style={{ fontSize: web ? 18 : 14 }}>
                  To import your bank information, we utilize a third-party
                  vendor named Plaid. We are connecting you now…
                </CustomText>
              </View>
            </View>
          )}
          {isBankAccountLinked !== 1 && renderLogin()}
          {isBankAccountLinked != 0 && <PlaidStatus />}
          {processingStatus && From == "loginverify" && (
            <View style={styles.Wrapper}>
              {processingStatus == "success" ? (
                <View
                  style={{
                    marginVertical: 60,
                    justifyContent: "space-between",
                    flex: 1,
                    alignItems: "center",
                  }}
                >
                  <CustomText style={{ fontSize: 20 }}>
                    Thank you. Your bank Verification steps are done for now.
                  </CustomText>
                  <View style={{ flexDirection: "row" }}>
                    <IconButton
                      style={{ marginRight: 10 }}
                      onPress={() => {
                        //navigate("DashBoard", {});

                        const URL = `${window.location.origin}/GoDirect/index.html?SessionId=${SessionId}&uid=${uniqueId}&Path=DashBoard`;
                        try {
                          window.parent.location.href = URL;
                        } catch (e) {
                          window.location.href = URL;
                        }
                      }}
                      title="View Remaining Loan Tasks"
                    />
                    <IconButton
                      style={{ marginRight: 10 }}
                      onPress={handleLogOut}
                      title="Log Out"
                      buttonType="secondary"
                    />
                  </View>
                </View>
              ) : processingStatus == "Importing" ? (
                <View
                  style={[
                    {
                      ...{
                        flexDirection: "row",
                        paddingTop: 20,
                      },
                    },
                  ]}
                >
                  <CustomText
                    style={{
                      marginRight: 5,
                      marginLeft: 2,
                      height: web ? "auto" : 35,
                    }}
                  >
                    <ArrowSpinner
                      style={{ height: 25, marginTop: 0 }}
                      size={22}
                    />
                  </CustomText>
                  <View
                    style={{
                      flexDirection: "column",
                      flex: 1,
                      height: web ? "auto" : 40,
                    }}
                  >
                    <CustomText
                      style={{ fontSize: web ? 20 : 18, marginBottom: 10 }}
                      bold={true}
                    >
                      Importing Bank details form Plaid...
                    </CustomText>
                  </View>
                </View>
              ) : (
                <View
                  style={{
                    marginVertical: 50,
                    justifyContent: "space-between",
                    flex: 1,
                  }}
                >
                  <CustomText
                    style={{
                      fontSize: 20,
                      flexDirection: "column",
                      display: "flex",
                    }}
                  >
                    <CustomText>
                      We apologize… An error was found as follows:
                    </CustomText>
                    <CustomText>{processingStatus}</CustomText>
                  </CustomText>

                  <View style={{ flexDirection: "row", alignSelf: "center" }}>
                    <IconButton
                      style={{ marginRight: 10 }}
                      onPress={() => {
                        window.location.reload();
                      }}
                      title="Try Again"
                    />
                    <IconButton
                      style={{ marginRight: 10 }}
                      onPress={() => {
                        // navigate("DashBoard", {});

                        URL = `${window.location.origin}/GoDirect/index.html?SessionId=${SessionId}&uid=${uniqueId}&Path=DashBoard`;
                        try {
                          window.parent.location.href = URL;
                        } catch (e) {
                          window.location.href = URL;
                        }
                      }}
                      title="View Remaining Loan Tasks"
                    />
                    <IconButton
                      style={{ marginRight: 10 }}
                      onPress={handleLogOut}
                      title="Log Out"
                      buttonType="secondary"
                    />
                  </View>
                </View>
              )}
            </View>
          )}
          <View
            style={{
              flexDirection: "column",
              backgroundColor: "#404040",
              paddingVertical: 25,
              position: "absolute",
              bottom: 0,
              width: "100%",
            }}
          >
            <View
              style={{
                flexDirection: "row",
                width: "28%",
                alignSelf: "center",
                justifyContent: "space-evenly",
                marginBottom: 15,
              }}
            >
              <CustomText
                onPress={() => Linking.openURL("../")}
                style={{ color: "#B6B6B6" }}
              >
                Home
              </CustomText>
              <CustomText
                onPress={() => Linking.openURL("../../licensing/")}
                style={{ color: "#B6B6B6" }}
              >
                Licensing
              </CustomText>
              <CustomText
                onPress={() => Linking.openURL("../../privacy-policy/")}
                style={{ color: "#B6B6B6" }}
              >
                Privacy policy
              </CustomText>
              <CustomText
                onPress={() => Linking.openURL("../../terms-of-use/")}
                style={{ color: "#B6B6B6" }}
              >
                Terms of Use
              </CustomText>
            </View>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-around",
                width: "45%",
                alignItems: "center",
                alignSelf: "center",
              }}
            >
              <TouchableOpacity
                onPress={() => Linking.openURL("../")}
                style={{ width: "20%" }}
              >
                <Image
                  style={{
                    position: "relative",
                    height: 80,
                  }}
                  resizeMode="contain"
                  source={require("../../assets/DMCFooter.png")}
                />
              </TouchableOpacity>
              <View style={{ alignItems: "center" }}>
                <CustomText style={{ color: "#B6B6B6", marginBottom: 10 }}>
                  © 2024 Direct Mortgage, Corp. ALL RIGHTS RESERVED
                </CustomText>
                <CustomText style={{ color: "#B6B6B6" }}>
                  6955 S. Union Park Center Suite 540, Midvale, UT 84047 | NMLS
                  ID 9612
                </CustomText>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  width: 100,
                  alignItems: "flex-end",
                }}
              >
                <TouchableOpacity
                  onPress={() => Linking.openURL("https://www.fhfa.gov/")}
                  style={{ width: "55%" }}
                >
                  <Image
                    style={{
                      position: "relative",
                      height: 70,
                    }}
                    resizeMode="contain"
                    source={require("../../assets/EqualHousingWhite.png")}
                  />
                </TouchableOpacity>
                <TouchableOpacity
                  onPress={() =>
                    Linking.openURL("https://www.nmlsconsumeraccess.org/")
                  }
                  style={{ width: "100%" }}
                >
                  <Image
                    style={{
                      position: "relative",
                      height: 74,
                    }}
                    resizeMode="contain"
                    source={require("../../assets/NMLS White.png")}
                  />
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </div>
      ) : (
        <View
          style={[
            styles.container,
            contextDetails["fullScreen"]
              ? {
                  width: 400,
                  minHeight: 608,
                  alignSelf: "center",
                  marginVertical: 100,
                  backgroundColor: "#fff",
                  borderRadius: 5,
                  padding: 15,
                  boxShadow: "rgba(0, 0, 0, 0.08) 3px 7px 10px 4px",
                }
              : {},
          ]}
        >
          {isLoading && isBankAccountLinked !== 1 && (
            <>
              <View
                style={[
                  {
                    ...{
                      flexDirection: "row",
                      paddingTop: 20,
                    },
                  },
                ]}
              >
                <CustomText
                  style={{
                    marginRight: 5,
                    marginLeft: 2,
                    height: web ? "auto" : 35,
                  }}
                >
                  <ArrowSpinner
                    style={{ height: 25, marginTop: 0 }}
                    size={22}
                  />
                </CustomText>
                <View
                  style={{
                    flexDirection: "column",
                    flex: 1,
                    height: web ? "auto" : 40,
                  }}
                >
                  <CustomText
                    style={{ fontSize: web ? 20 : 18, marginBottom: 10 }}
                    bold={true}
                  >
                    Connecting to Plaid...
                  </CustomText>
                </View>
              </View>
              <View style={{ flexDirection: "row" }}>
                <CustomText style={{ fontSize: web ? 18 : 14 }}>
                  To import your bank information, we utilize a third-party
                  vendor named Plaid. We are connecting you now…
                </CustomText>
              </View>
            </>
          )}
          {isBankAccountLinked !== 1 && renderLogin()}
          {isBankAccountLinked != 0 && <PlaidStatus />}
        </View>
      )}
    </ScrollContainer>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    height: 525,
  },
  Wrapper: {
    backgroundColor: "#fff",
    paddingTop: 20,
    paddingBottom: 10,
    paddingHorizontal: web ? 20 : 0,
    borderRadius: 20,
    overflow: "auto",
    boxShadow: "rgb(0 0 0 / 13%) 2px 4px 18px 10px",
    flex: 1,
    width: 600,
    marginHorizontal: "auto",
    marginVertical: 100,
    minHeight: 350,
  },
});
export default Plaid;
